import axios from 'axios';

export default async function sendVerification(
  accessToken,
  userId,
  locationId,
  method,
  recipientInfo,
  addressLines,
  regionCode,
  postalCode,
  locality,
  administrativeArea,
  businessType,
) {
  const requestOptions = {
    headers: {
      'access-token': accessToken,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_GOOGLE_API_URL}/initiate/verification/process/${userId}/${locationId}`,
      {
        method,
        recipientInfo,
        addressLines,
        regionCode,
        postalCode,
        locality,
        administrativeArea,
        businessType,
      },
      requestOptions,
    );

    return data;
  } catch (err) {
    throw err.response.data;
  }
}
